import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

// Icon utility functions
export const getPositionTypeIcon = (positionType: string) => {
  switch (positionType) {
    case 'STOCK':
      return <TrendingUp className="w-5 h-5 text-green-600" />;
    case 'OPTION':
      return <TrendingDown className="w-5 h-5 text-red-600" />;
    default:
      return <Minus className="w-5 h-5 text-gray-600" />;
  }
};

export const getRankIcon = (rank: number) => {
  if (rank === 1) return <span className="text-2xl">🥇</span>;
  if (rank === 2) return <span className="text-2xl">🥈</span>;
  if (rank === 3) return <span className="text-2xl">🥉</span>;
  return <span className="text-lg">#{rank}</span>;
};
